import React, { useEffect } from 'react'
import { Switch } from '@mui/material'
import { FieldTitle, useInput } from 'react-admin';

export const BooleanInput = ({ source, value, onChange, label, validate, defaultValue, ...props }) => {
  const { field } = useInput({source, validate, defaultValue})

  useEffect(() => {
    if (value !== undefined) {
      field.onChange(value)
    }
  }, [value])

  const onChangeField = (e) => {
    field.onChange(e.target.checked)
    onChange && onChange(e)
  }

  return (
    <>
      <Switch
        onChange={onChangeField}
        checked={field.value}
        {...props}
      />
      <FieldTitle
        label={label}
        source={source}
      />
    </>
  )
}
